<template>
    <div>
        <gmap-map
            ref="googleMap"
            id="members-map"
            :style="`width:100%;  height: 300px`"
            :center="map.center"
            :zoom="map.zoom"
            :options="options"
        >
            <gmap-marker
                style="height:25px; width:25px;"
                :icon="marker.icon"
                :position="marker.position"
                :clickable="true"
                :draggable="false"
                @click="toggleInfoWindow"
            >
            </gmap-marker>
            <gmap-info-window
                :options="infoWindowOptions"
                :position="infoWindowPosition"
                :opened="infoWindowOpen"
                @click="closeInfoWindow"
                @closeclick="closeInfoWindow"
                maxWidth="200px"
                ref="infoWindow"
            >
                <div v-html="infoWindowContent"></div>
            </gmap-info-window>
        </gmap-map>
    </div>
</template>

<script>
    export default {
        name: "MembersItemMap",
        props: {
            input_center: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        lat : 41.850033,
                        lng : -98.6500523
                    }
                },
            },
            input_member: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                map: {
                    zoom: 8,
                    center: {
                        lat: this.input_center.latitude,
                        lng: this.input_center.longitude,
                    }
                },
                marker: {
                    position: {
                        lat: this.input_center.latitude,
                        lng: this.input_center.longitude,
                    },
                    icon: {
                        url: `/img/marker.png`,
                        scaledSize: {width: 40, height: 50},
                        labelOrigin: {x: 16, y: -10}
                    },
                    formatted_address: null,
                },
                user: {
                    currentPosition: {
                        lat: null,
                        lng: null
                    },
                    formatted_address: null,
                    error: null
                },
                infoWindowContent: '',
                infoWindowPosition: {lat: 0, lng: 0},
                infoWindowOpen: false,
                infoWindowOptions: { pixelOffset: {width: 0, height: -50 }},
                currentMarkerIndex: null,
                options: {
                    navigationControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    draggable: true,
                    minZoom: 3,
                    maxZoom: 20,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUi: true,
                    styles: [
                        {
                            elementType: "geometry",
                            stylers: [{ color: "#f5f5f5" }],
                        },
                        {
                            elementType: "labels.icon",
                            stylers: [{ visibility: "off" }],
                        },
                        {
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#050505" }],
                        },
                        {
                            elementType: "labels.text.stroke",
                            stylers: [{ color: "#f5f5f5" }],
                        },
                        {
                            featureType: "administrative.land_parcel",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#bdbdbd" }],
                        },
                        {
                            featureType: "poi",
                            elementType: "geometry",
                            stylers: [{ color: "#eeeeee" }],
                        },
                        {
                            featureType: "poi",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#757575" }],
                        },
                        {
                            featureType: "poi.park",
                            elementType: "geometry",
                            stylers: [{ color: "#e5e5e5" }],
                        },
                        {
                            featureType: "poi.park",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#9e9e9e" }],
                        },
                        {
                            featureType: "road",
                            elementType: "geometry",
                            stylers: [{ color: "#ffffff" }],
                        },
                        {
                            featureType: "road.arterial",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#757575" }],
                        },
                        {
                            featureType: "road.highway",
                            elementType: "geometry",
                            stylers: [{ color: "#dadada" }],
                        },
                        {
                            featureType: "road.highway",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#616161" }],
                        },
                        {
                            featureType: "road.local",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#9e9e9e" }],
                        },
                        {
                            featureType: "transit.line",
                            elementType: "geometry",
                            stylers: [{ color: "#e5e5e5" }],
                        },
                        {
                            featureType: "transit.station",
                            elementType: "geometry",
                            stylers: [{ color: "#eeeeee" }],
                        },
                        {
                            featureType: "water",
                            elementType: "geometry",
                            stylers: [{ color: "#c9c9c9" }],
                        },
                        {
                            featureType: "water",
                            elementType: "labels.text.fill",
                            stylers: [{ color: "#9e9e9e" }],
                        },
                    ],
                },
            }
        },
        mounted() {
          this.allowCurrentGeolocation();
          this.setCompanyFormattedAddress();
        },
        methods: {
            toggleInfoWindow() {
                this.infoWindowOpen = !this.infoWindowOpen;

                this.infoWindowPosition = this.marker.position;
                this.infoWindowContent = `
                    <strong style="margin: 0 20px 10px">${this.input_member.company}</strong>
                    <div class="row">
                        <div class="col-12 m-2">
                          <span class="req">${this.input_member.address}</span>
                        </div>
                        <div class="col-12">
                            <span class="req">${this.input_member.phone}</span>
                        </div>
                    </div>
                `;
            },
            closeInfoWindow() {
                this.infoWindowOpen = false;
            },
            allowCurrentGeolocation() {
                if (navigator.geolocation) {
                    const successCallback = (response) => {
                        this.user.currentPosition = {
                            lat: response.coords.latitude,
                            lng: response.coords.longitude
                        }

                        this.setFormattedAddress(response.coords.latitude, response.coords.longitude, this.user);
                    }

                    const errorCallback = (error) => {
                        if (error.code === error.PERMISSION_DENIED) {
                            this.user.error = error.message;
                        }
                    }

                    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
                }
            },
            setFormattedAddress(lat, lng, target) {
                $.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat}, ${lng}&key=${process.env.MIX_GOOGLE_MAPS_KEY}&language=en`, (data) => {
                    target.formatted_address = data.results[0].formatted_address;
                });
            },
            setCompanyFormattedAddress() {
                this.setFormattedAddress(this.marker.position.lat, this.marker.position.lng, this.marker);
            },
        }
    }
</script>

<style lang="less">
    .gm-style .gm-style-iw-t::after {
        background: none !important;
    }

    .gm-style .gm-style-iw {
        width: 250px !important;
    }

    .gm-style-cc {
        display: none !important;
    }

    .gm-style-iw-c {
        height: 120px !important;
        max-width: 220px !important;
        padding-top: 25px !important;
    }
    .gm-style-iw-d {
        overflow: hidden !important;
        text-align: center;
    }
</style>
